import { useEnvStore } from '@remote/store/env'
import { store } from '@remote/store'
import { isProd } from '@remote/api/config'
import { judgeClient, isNativeApp, isInXunleiApp, isInPCXunlei } from '@remote/utils'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=73502372
const device = judgeClient()

export const getReferVisit = () => {
  if (isNativeApp()) return 'app'
  if (isInXunleiApp()) return 'xl'
  if (isInPCXunlei()) return 'pcxl'
  if (global.fromApp) return global.fromApp
  return 'br'
}

interface StatData {
  type?: string
  action?: string
  category?: string
  options?: Record<string, any>
  data?: Record<string, any>
}

export function stat (_data: StatData) {
  const envStore = useEnvStore()
  const { type = 'event', action, category = 'remote_control_h5', options, data } = _data
  if (!isProd) {
    console.log(type, action, category, options, data)
  }
  const userid = envStore.userID || store.state?.deviceInfoWatchData?.user?.id || '0'
  const vip_type = store.state.deviceInfoWatchData?.user?.vip?.vastype || global.vipType || '0'
  const is_vip = store.state.deviceInfoWatchData?.user?.vip?.is_vip || '0'
  const guid = global.guid || ''
  const peerid = global.peerid || ''
  const cooperid = envStore.platform || 'unknown'
  const visit = getReferVisit()
  const develop = 'pg'
  window.xla.push({
    type,
    category,
    action,
    extdata: {
      platform: 'XL_HeZi',
      clientType: `${device}_${visit}_${develop}`,
      businessType: 'remote_control',
      cooperid,
      userid,
      peerid,
      guid,
      cookid: '',
      vip_type,
      is_vip,
      ...options,
      ...data,
    },
  })
}
